"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectField = exports.radio = exports.checkbox = exports.hr = exports.gaplessColumns = exports.mobileColumns = exports.columns = exports.fieldset = exports.field = exports.textarea = exports.formFor = void 0;
const mithril_1 = __importDefault(require("mithril"));
const helpers_1 = require("../utils/helpers");
const alert_box_1 = require("./alert_box");
const choices_1 = require("./choices");
function formFor(obj, provider, cb) {
    let ajaxCall = provider.isAjaxing();
    let globalAttrs = {};
    globalAttrs.disabled = ajaxCall;
    function mixAttrs(...x) {
        return Object.assign({}, globalAttrs, ...x);
    }
    let errorMap = {};
    let forceState = 'auto';
    if (provider.lastError && provider.lastError.fields) {
        for (let i = 0; i < provider.lastError.fields.length; i++) {
            let [k, v] = provider.lastError.fields[i];
            errorMap[k] = errorMap[k] || [];
            errorMap[k].push(v);
        }
    }
    let cbs = [];
    let form = {
        obj: obj,
        onbeforesubmit(cb) {
            cbs.push(cb);
        },
        field(label, name, type = "text", attrs) {
            let mixin = {};
            if (errorMap[name]) {
                mixin = { class: "input is-danger", error: errorMap[name] };
            }
            attrs = attrs || {};
            if (type == "number" && !attrs["transformValue"]) {
                attrs["transformValue"] = function (x) {
                    let f = parseFloat(x);
                    return isNaN(f) ? 0 : f; // Is nan is probably because the field is empty.
                };
            }
            return field(label, name, type, obj, mixAttrs(attrs, mixin));
        },
        fieldset(label, opts, ...content) {
            return fieldset(label, opts, ...content);
        },
        selectField(label, name, options, attrs) {
            let mixin = { class: "" };
            if (errorMap[name]) {
                mixin = { class: "is-danger", error: errorMap[name] };
            }
            return selectField(label, name, options, obj, mixAttrs(mixin, attrs));
        },
        checkbox(label, name, attrs) {
            return checkbox(label, name, obj, mixAttrs(attrs));
        },
        radio(label, name, attrs) {
            return radio(label, name, obj, mixAttrs(attrs));
        },
        textarea(label, name, attrs) {
            let mixin = { class: "textarea" };
            if (errorMap[name]) {
                mixin = { class: "is-danger textarea", error: errorMap[name] };
            }
            return textarea(label, name, obj, mixAttrs(mixin, attrs));
        },
        submit(name, attrs = {}) {
            const submitComponent = function () {
                function handleClick(e) {
                    e.preventDefault();
                    mithril_1.default.redraw();
                    let promise;
                    cbs.forEach(cb => { cb(obj); });
                    if (attrs.ajax) {
                        promise = attrs.ajax(obj);
                    }
                    else {
                        if (form.isEdit()) {
                            promise = provider.update(obj);
                        }
                        else {
                            promise = provider.create(obj);
                        }
                    }
                    promise.then((data) => {
                        if (attrs.onsubmit) {
                            attrs.onsubmit(data);
                        }
                    });
                }
                function view(_v) {
                    let defaultClasses = "";
                    if (attrs && attrs.class)
                        defaultClasses = attrs.class;
                    let klass = provider.ajaxCall > 0 ? `button is-info is-loading ${defaultClasses}` : `button is-info ${defaultClasses}`;
                    let defAttr = Object.assign({
                        onclick: handleClick
                    }, attrs);
                    defAttr["class"] = klass;
                    return (0, mithril_1.default)("button", defAttr, name);
                }
                return { view };
            };
            return (0, mithril_1.default)(submitComponent);
        },
        errorBlock() {
            if (provider.lastError) {
                let infos = provider.lastError.infos || "Une ou plusieurs erreurs empechent la sauvegarde";
                return (0, alert_box_1.alertBox)({
                    content: infos,
                    level: "danger",
                    onclose: () => { provider.clearError(); }
                });
            }
            return undefined;
        },
        setOperationType(type) {
            forceState = type;
            return this;
        },
        isNew() {
            switch (forceState) {
                case 'auto': return obj["id"] === undefined;
                case 'new': return true;
            }
            return false;
        },
        isEdit() {
            switch (forceState) {
                case 'auto': return !this.isNew();
                case 'edit': return true;
            }
            return false;
        }
    };
    return (0, mithril_1.default)("form", cb(form));
}
exports.formFor = formFor;
function textarea(label, name, obj, opts) {
    let args = Object.assign({
        class: "textarea",
        name: name,
        oninput: (e) => {
            obj[name] = e.target.value;
        }
    }, opts);
    return (0, mithril_1.default)("div", { class: "field" }, (0, mithril_1.default)("label", { class: "label" }, label), (0, mithril_1.default)("div", { class: "control" }, (0, mithril_1.default)("textarea", args, obj[name]), (opts.error ? (0, mithril_1.default)("div", { class: "has-text-danger is-italic" }, opts.error) : undefined)));
}
exports.textarea = textarea;
function field(label, name, type, obj, opts) {
    const renderValue = opts.renderValue || helpers_1.identity;
    const transformValue = opts.transformValue || helpers_1.identity;
    let args = Object.assign({
        class: "input",
        type: type,
        name: name,
        value: renderValue(obj[name]),
        oninput: (e) => {
            obj[name] = transformValue(e.target.value);
        }
    }, opts);
    return (0, mithril_1.default)("div", { class: "field" }, (0, mithril_1.default)("label", { class: "label" }, label), (0, mithril_1.default)("div", { class: "control" }, (0, mithril_1.default)("input", args)), (opts.error ? (0, mithril_1.default)("div", { class: "has-text-danger is-italic" }, opts.error) : undefined));
}
exports.field = field;
function fieldset(label, opts, ...content) {
    opts = Object.assign({ class: "box" }, opts);
    return (0, mithril_1.default)("fieldset", opts, (0, mithril_1.default)("legend", { class: "label subtitle is-4 white-bg" }, label), ...content);
}
exports.fieldset = fieldset;
/**
 * Setup the items in a div with each having a column.
 */
function columns(...items) {
    return (0, mithril_1.default)(".columns", items.map(x => { return x ? (0, mithril_1.default)("div", { class: "column" }, x) : undefined; }));
}
exports.columns = columns;
function mobileColumns(...items) {
    return (0, mithril_1.default)(".columns.is-mobile", items.map((x) => { return x ? (0, mithril_1.default)("div", { class: "column" }, x) : undefined; }));
}
exports.mobileColumns = mobileColumns;
/**
 * Setup the items in a div with each having a column.
 */
function gaplessColumns(...items) {
    return (0, mithril_1.default)("div", { class: "columns is-gapless" }, items.map((x) => { return x ? (0, mithril_1.default)("div", { class: "column" }, x) : undefined; }));
}
exports.gaplessColumns = gaplessColumns;
function hr() {
    return (0, mithril_1.default)("hr");
}
exports.hr = hr;
function checkbox(label, name, obj, opts) {
    let args = Object.assign({
        type: "checkbox",
        checked: obj[name],
        oninput: (e) => {
            obj[name] = e.target.checked;
        }
    }, opts);
    return (0, mithril_1.default)("label", { class: "checkbox" }, (0, mithril_1.default)("input", args), label);
}
exports.checkbox = checkbox;
function radio(label, name, obj, opts) {
    opts = opts || {};
    let args = Object.assign({
        type: "radio",
        checked: obj[name] === opts.value,
        oninput: (e) => {
            obj[name] = e.target.value;
        }
    }, opts);
    return (0, mithril_1.default)("label", { class: "radio" }, (0, mithril_1.default)("input", args), label);
}
exports.radio = radio;
function selectField(label, name, options, obj, opts) {
    options = options || {};
    let value = obj[name];
    let args = Object.assign({
        class: "full-width",
        name: name,
        value: value,
        oninput: (e) => {
            let previousValue = obj[name];
            if (e.target.value == "") {
                delete obj[name];
            }
            else {
                obj[name] = e.target.value;
            }
            if (opts.afterchange) {
                opts.afterchange(obj, obj[name], previousValue);
            }
        }
    }, opts);
    function select(hasError) {
        let optionsElements = [];
        if (opts.allowBlank) {
            optionsElements.push((0, mithril_1.default)("option", { value: "", key: "" }, ""));
        }
        if (options instanceof Array) {
            options.forEach((it) => {
                optionsElements.push((0, mithril_1.default)("option", { value: it[0], key: it[0], selected: (it[0] == value) }, it[1]));
            });
        }
        else {
            if (options.constructor == Promise) {
                let p = options;
                p.then(arr => {
                    arr.forEach((it) => {
                        optionsElements.push((0, mithril_1.default)("option", { value: it[0], key: it[0], selected: (it[0] == value) }, it[1]));
                    });
                });
            }
            else {
                for (let k in options) {
                    let v = options[k];
                    optionsElements.push((0, mithril_1.default)("option", { value: k, key: k, selected: (k == value) }, v));
                }
            }
        }
        return (0, mithril_1.default)("div", { class: `for-select ${hasError && "is-danger"}` }, (0, mithril_1.default)(choices_1.Select, args, optionsElements));
    }
    return (0, mithril_1.default)("div", { class: "field" }, (0, mithril_1.default)("label", { class: "label" }, label), (0, mithril_1.default)("div", { class: "control" }, select(!!opts.error)), (opts.error ? (0, mithril_1.default)("div", { class: "has-text-danger is-italic" }, opts.error) : undefined));
}
exports.selectField = selectField;
